import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { PlatformServices } from '@williswelby/platform'

@Injectable()
export class CalculatorProvider {
  private platform = new PlatformServices();

  constructor() {
  }

  calculate(company:any = {}, flexOptions) {
    return new Promise((resolve, reject) => {
      const result = this.platform.calculateExpectations(company, flexOptions);
      resolve(result);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/calculator/calculator.ts